import { ArrowLeftIcon } from '@radix-ui/react-icons'
import { ChevronLeft } from 'lucide-react'

import { Button } from '@/components/ui/button'

import { cx } from '@/lib/cva-config'

interface SidebarToggleProps {
  isOpen: boolean | undefined
  setIsOpen?: () => void
}

export function SidebarToggle({ isOpen, setIsOpen }: SidebarToggleProps) {
  return (
    <div className="invisible absolute -right-[16px] top-[12px] z-20 lg:visible">
      <Button
        onClick={() => setIsOpen?.()}
        className="h-8 w-8 rounded-md"
        // variant="outline"
        variant="primary"
        size="icon"
      >
        <ArrowLeftIcon
          className={cx(
            'h-4 w-4 transition-transform duration-500 ease-in-out',
            isOpen === false ? 'rotate-180' : 'rotate-0'
          )}
        />
      </Button>
    </div>
  )
}
